import { render } from "./WalletMoneySummaryCard.vue?vue&type=template&id=6b7bcfe1&scoped=true"
import script from "./WalletMoneySummaryCard.vue?vue&type=script&lang=js"
export * from "./WalletMoneySummaryCard.vue?vue&type=script&lang=js"

import "./WalletMoneySummaryCard.vue?vue&type=style&index=0&id=6b7bcfe1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7bcfe1"]])

export default __exports__